export const SAMPLE_ADD_STOCK_MANIFEST_LISTS = {
  serialisedManifestData: [],
  nonSerializedManifestData: [] 
};

export const SAMPLE_PARTTYPE_BULK_LIVESEARCH_INSERTION_DATA = {
  searchableValues: [],
  applicableNodeId: ''
};